/* eslint-disable no-async-promise-executor */
import {
	Alert,
	Button,
	Card,
	Col,
	Icon,
	Input,
	notification,
	Row,
	Select,
	Spin,
	Tabs,
	Upload,
} from 'antd';
import message from '../utils/messageWithScroll';
import { Bitrix24Consumer } from 'contexts/legacy/Bitrix24Context';
import { LanguageConsumer } from 'contexts/legacy/LanguageContext';
import { NumberConsumer } from 'contexts/legacy/NumberContext';
import { SystemConsumer } from 'contexts/legacy/SystemContext';
import debounce from 'lodash/debounce';
import find from 'lodash/find';
import findIndex from 'lodash/findIndex';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { api } from 'services/api';

const { Option } = Select;
const { TextArea } = Input;
const { TabPane } = Tabs;

class MessageItemMobile extends Component {
	constructor(props) {
		super(props);
		this.state = {
			infos: {
				domain: '',
				auth: '',
			},
			msg: '',
			from: '',
			fromId: '',
			auxPhoneList: [],
			phoneList: [],
			selectedPhoneList: [],
			phoneListFetching: false,
			files: [],
			value: undefined,
			deal_stage: null,
			deal_category: null,
			lead_status: null,
			tabKey: 'contact',
			is_log_message_view: false,
			showTemplateLayout: false,
			selectedTemplateArray: [],
			selectedTemplate: {},
			templateList: [],
			isSendingMessage: false,
			maxFileSize: false,
		};

		this.fetchUserList = debounce(this.fetchUserList, 800);
	}

	handleChangeTemplate(index) {
		const template = this.state.templateList[index];

		if (template) {
			template.components.forEach((component) => {
				if (component.type === 'BODY') {
					const templateArray = component.text.replace(/({{\w}})/g, '{{}}').split(/({{}})/);

					this.state.selectedTemplateArray.forEach((item, index) => {
						if (item.includes('{{')) {
							document.getElementById(`input-${index}`).value = '';
						}
					});

					this.setState({
						selectedTemplateArray: templateArray,
					});
				}
			});

			this.setState({ selectedTemplate: template });
		}
	}

	async getTemplateList(from, fromApi) {
		const data = {
			action: 'getTemplateList',
			api: fromApi,
			sender: from,
			domain: this.state.infos.domain,
			auth: this.state.infos.auth,
		};

		await api.post('getTemplateList', data).then(async (res) => {
			if (res.data.dados) {
				this.setState({ templateList: res.data.dados });
				if (res.data.dados.errors) {
					this.handleTemplateError();
				}
			} else {
				this.setState({ templateList: [] });
			}
		});
	}

	handleTemplateDefaults(index, e) {
		const { value } = e.target;

		const templateStringArray = this.state.selectedTemplateArray;
		templateStringArray[index] = '{{' + value + '}}';
		this.setState({ selectedTemplateArray: templateStringArray });
	}

	async componentDidMount() {
		window.BX24.init(async () => {
			const auth = window.BX24.getAuth();
			const domain = auth.domain;

			await this.loadClientInfos(domain);
		});
	}

	handleChangeFrom(index) {
		const value = this.props.number.numbers.actives[index];

		this.setState({
			from: value.number,
			fromId: value.id,
			fromApi: value.api,
		});

		if (value.api === 'messageBird') {
			this.setState({ showTemplateLayout: true });
			this.getTemplateList(value.number, value.api);
		} else {
			this.setState({ showTemplateLayout: false });
		}
	}

	handleChangeTo(value) {
		this.setState({ to: value });
	}

	loadClientInfos(domain) {
		return new Promise(async (resolve, reject) => {
			this.setState({ loadingClient: true });

			const request = {
				action: 'getClient',
				domain,
			};

			await api.post('getClient', request).then(async (res) => {
				this.setState({ loadingClient: false });
				if (res.data.status) {
					this.setState({ infos: res.data.dados });
					resolve(res.data);
				} else {
					reject(res.data);
				}
			});
		});
	}

	onChangeMessage = (e) => {
		const { value } = e.target;
		this.setState({ msg: value });
	};

	dummyRequest({ onSuccess }) {
		setTimeout(() => {
			onSuccess('ok');
		}, 0);
	}

	beforeUpload = (file) => {
		if (file.size > 104857600) {
			this.setState({ maxFileSize: true });
		} else {
			this.setState({ maxFileSize: false });
		}

		const files = [file];
		this.setState({ files });
	};

	createMetaMsg(isMessageBird, hide) {
		const {
			from,
			fromId,
			selectedPhoneList,
			msg,
			files,
			tabKey,
			fromApi,
			selectedTemplateArray,
			selectedTemplate,
		} = this.state;
		const { language } = this.props.language;
		let metaMsg = {};

		if (from === '') {
			throw language.from_empty;
		}

		if (selectedPhoneList === '') {
			throw language.to_empty;
		}

		if (this.state.files.length > 0) {
			this.state.files.forEach((file) => {
				if (file.size > 104857600) {
					hide();
					this.setState({ isSendingMessage: false });
					throw language.warning_maximum_file_size;
				}
			});
		}

		if (isMessageBird) {
			const templateStringArray = selectedTemplateArray;
			const templateDefaults = [];

			for (const string of templateStringArray) {
				if (/{{.*}}/.test(string)) {
					let newString = string.replace('{{', '');
					newString = newString.replace('}}', '');
					if (newString === '') {
						throw language.params_empty;
					}
					templateDefaults.push({ default: newString });
				}
			}

			const params = templateDefaults;

			metaMsg = {
				params,
				from,
				to: selectedPhoneList,
				files,
				api: fromApi,
				templateName: selectedTemplate.name,
				templateLanguage: selectedTemplate.language,
				templateComponents: selectedTemplate.components,
				wabaId: selectedTemplate.wabaId || null,
				id_entity: tabKey,
				mobile: true,
			};

			return metaMsg;
		} else {
			if (msg === '') {
				throw language.msg_empty;
			} else {
				metaMsg = {
					from,
					fromId,
					to: selectedPhoneList,
					message: msg,
					files,
					id_entity: tabKey,
					mobile: true,
				};

				return metaMsg;
			}
		}
	}

	sendMsg = async (e) => {
		e.preventDefault();

		const { showTemplateLayout } = this.state;
		const { language } = this.props.language;

		try {
			this.setState({ isSendingMessage: true });

			const hide = message.loading(language.sending_message, 0);
			const metaMsg = this.createMetaMsg(showTemplateLayout, hide);

			await this.props.number
				.sendMessage(metaMsg)

				.then(() => {
					window.scrollTo({ top: 0, behavior: 'smooth' });

					hide();
					this.setState({ isSendingMessage: false });

					if (this.refs.msgText !== undefined) {
						const msgText = this.refs.msgText;
						msgText.state.value = '';
						this.setState({ msg: '' });
					}

					message.success(language.send_message_success);
				})
				.catch((e) => {
					if (e.msg) {
						message.error(e.msg);
					} else {
						message.error(language.send_message_error);
					}
				});
		} catch (e) {
			message.error(e);
		}
	};

	removeFile(file) {
		const { files } = this.state;
		const newFiles = files.filter(function (ele) {
			return ele !== file;
		});

		this.setState({ files: newFiles });
	}

	handleTemplateError() {
		if (this.state.showTemplateLayout && this.state.templateList.errors) {
			let errorDescription = this.state.templateList.errors[0].description;

			if (errorDescription.includes('Request was not authenticated')) {
				errorDescription += '.\n\n' + this.props.language.language.invalid_tokens;
			} else if (
				errorDescription.includes('You cannot use the Integrations API with a test access key')
			) {
				errorDescription += '.\n\n' + this.props.language.language.using_test_tokens;
			}

			notification.error({
				message: this.props.language.language.template_error,
				description: errorDescription,
				duration: 0,
			});
		}
	}

	handleTabChange(key) {
		const msgText = this.refs.msgText;
		msgText.state.value = '';

		this.setState({
			tabKey: key,
			phoneList: [],
			auxPhoneList: [],
			selectedPhoneList: [],
		});
	}

	handleChangeDealCategory = (value) => {
		this.props.number.getListOfDealsStagesFiltered(value);

		this.setState({
			deal_category: value,
			deal_stage: null,
			phoneList: [],
			auxPhoneList: [],
			selectedPhoneList: [],
		});
	};

	handleChangeDealStage = async (value) => {
		this.setState({
			deal_stage: value,
			phoneList: [],
			auxPhoneList: [],
			selectedPhoneList: [],
		});
	};

	handleChangeLeadStatus = (value) => {
		this.setState({
			lead_status: value,
			phoneList: [],
			auxPhoneList: [],
			selectedPhoneList: [],
		});
	};

	openLogMessages = () => {
		this.setState({ is_log_message_view: true });
	};

	closeLogMessages = () => {
		this.setState({ is_log_message_view: false });
	};

	async lumenFetch(value) {
		const params = {
			domain: this.props.bitrix24.infos.domain,
			auth: this.props.bitrix24.infos.auth,
			b24_access_token: this.props.number.b24_access_token,
			search: value,
		};

		let resource = null;

		switch (this.state.tabKey) {
			case 'contact':
				resource = '/contacts/filter';
				break;

			case 'lead':
				resource = '/contacts/filter/leads';
				params.status = this.state.lead_status;
				break;

			case 'deal':
				resource = '/contacts/filter/deals';
				params.category = this.state.deal_category;
				params.stage = this.state.deal_stage;
				break;

			default:
				break;
		}

		return await api.get(resource, { params });
	}

	async fetchUserList(user) {
		if (!user || user.length < 2) {
			this.setState({ phoneList: [] });
			return;
		}

		this.setState({ phoneListFetching: true });

		let { data } = await this.lumenFetch(user);

		switch (this.state.tabKey) {
			case 'contact':
			case 'deal':
				data = data.flatMap((user) =>
					user.phones.map((phone) => ({
						id: phone.id,
						to_id: user.id,
						label: user.full_name,
						value: phone.value,
					})),
				);
				break;

			case 'lead':
				data = data.flatMap((user) =>
					user.phones.map((phone) => ({
						id: phone.id,
						to_id: user.id,
						label: user.TITLE,
						value: phone.value,
					})),
				);
				break;

			default:
				break;
		}

		this.setState({ phoneList: data, phoneListFetching: false });
	}

	handleChangeAuxPhoneList = (value) => {
		this.setState({
			auxPhoneList: value,
		});
	};

	handleOnSelectPhoneList = (value) => {
		const phoneObj = find(this.state.phoneList, (phone) => phone.id === value.key);

		const phoneNumber = phoneObj.value;

		this.state.selectedPhoneList.push(phoneNumber);

		this.setState({ selectedPhoneList: this.state.selectedPhoneList });
	};

	handleDeselectPhoneList = (value) => {
		const phoneIndex = findIndex(this.state.selectedPhoneList, (phone) => phone.id === value.key);

		this.state.selectedPhoneList.slice(phoneIndex, 1);

		this.setState({ selectedPhoneList: this.state.selectedPhoneList });
	};

	render() {
		let defaultTemplateValue;

		return (
			<>
				<div
					style={{
						border: '1px dashed #e9e9e9',
						backgroundColor: '#fff',
						borderRadius: 6,
						padding: 5,
						textAlign: 'left',
					}}
				>
					{this.state.is_log_message_view && (
						<>
							<Button
								type="primary"
								onClick={this.closeLogMessages.bind(this)}
								style={{
									display: 'inline-block',

									padding: '5px 70px',
									backgroundColor: '#bbed21',
									borderRadius: 0,
									textAlign: 'center',
									marginBottom: 10,
									color: '#535c69',
									fontWeight: 600,

									width: '100%',
									border: 'none',
									boxShadow: 'none',
								}}
							>
								<FormattedMessage id="back" />
							</Button>
						</>
					)}

					{!this.state.is_log_message_view && (
						<>
							<Tabs type="card" onChange={this.handleTabChange.bind(this)}>
								<TabPane tab="Contato" key="contact" disabled={this.state.isSendingMessage} />
								<TabPane tab="Lead" key="lead" disabled={this.state.isSendingMessage}>
									<Row>
										<Col span={24}>
											<div style={{ padding: 5 }}>
												<FormattedMessage id="lead_status" />
												<Select
													style={{ width: '100%' }}
													onChange={this.handleChangeLeadStatus.bind(this)}
												>
													{this.props.number.leads_statuses.map((status) => (
														<Option key={status.ID} value={status.STATUS_ID}>
															{status.NAME}
														</Option>
													))}
												</Select>
											</div>
										</Col>
									</Row>
								</TabPane>
								<TabPane tab="Negócio" key="deal" disabled={this.state.isSendingMessage}>
									<Row>
										<Col span={24}>
											<div style={{ padding: 5 }}>
												<FormattedMessage id="deal_category" />
												<Select
													style={{ width: '100%' }}
													onChange={this.handleChangeDealCategory.bind(this)}
													loading={this.props.number.loadingDealsCategories}
												>
													{this.props.number.deals_categories.map((category) => (
														<Option key={category.ID} value={category.ID}>
															{category.NAME}
														</Option>
													))}
												</Select>
											</div>
										</Col>
									</Row>
									<Row>
										<Col span={24}>
											<div style={{ padding: 5 }}>
												<FormattedMessage id="deal_stage" />
												<Select
													style={{ width: '100%' }}
													onChange={this.handleChangeDealStage.bind(this)}
													loading={this.props.number.loadingDealsStages}
												>
													{this.props.number.deals_stages.map((stage) => (
														<Option key={stage.STATUS_ID} value={stage.STATUS_ID}>
															{stage.NAME}
														</Option>
													))}
												</Select>
											</div>
										</Col>
									</Row>
								</TabPane>
							</Tabs>

							<Row>
								<Col span={24}>
									<div style={{ padding: 5 }}>
										<FormattedMessage id="from_number" />
										<Select
											style={{ width: '100%' }}
											placeholder={this.props.language.language.select_number}
											onChange={this.handleChangeFrom.bind(this)}
											optionLabelProp="label"
											loading={this.props.number.loadingNumber}
											disabled={this.state.isSendingMessage}
										>
											{this.props.number.numbers.actives.map((number, index) => (
												<Option
													key={number.id}
													value={index}
													label={number.name ? number.name + ' - ' + number.number : number.number}
												>
													{number.name ? (
														<span
															role="img"
															aria-label={number.name}
															style={{
																marginRight: 6,
																backgroundColor: '#bbed21',
																padding: 3,
																borderRadius: 10,
																minWidth: 30,
															}}
														>
															{number.name}
														</span>
													) : null}
													{number.number}
												</Option>
											))}
										</Select>
									</div>
								</Col>
							</Row>
							<Row>
								<Col span={24}>
									<div style={{ padding: 5 }}>
										<FormattedMessage id="to_numbers" />
										<Select
											mode="multiple"
											labelInValue
											value={this.state.auxPhoneList}
											placeholder={this.props.language.language.number}
											notFoundContent={this.state.phoneListFetching ? <Spin size="small" /> : null}
											filterOption={false}
											onSearch={this.fetchUserList.bind(this)}
											onChange={this.handleChangeAuxPhoneList.bind(this)}
											onSelect={this.handleOnSelectPhoneList.bind(this)}
											onDeselect={this.handleDeselectPhoneList.bind(this)}
											disabled={this.state.isSendingMessage}
											style={{ width: '100%' }}
										>
											{this.state.phoneList.length > 0 &&
												this.state.phoneList.map((d) => (
													<Option key={d.id} value={d.id}>
														{`${d.label} - ${d.value}`}
													</Option>
												))}
										</Select>
									</div>
								</Col>
								<Col span={24}>
									<div style={{ padding: 0 }}>
										<Card>
											{this.state.showTemplateLayout ? (
												<>
													<Col span={8}>
														<FormattedMessage id="Template" />
														<Select
															style={{ width: '100%' }}
															placeholder={this.props.language.language.template}
															onChange={this.handleChangeTemplate.bind(this)}
															disabled={!!this.state.templateList.errors}
															value={this.state.selectedTemplate.name}
														>
															{!this.state.templateList.length ? (
																<Option selected={true} key={0} value={0} />
															) : (
																this.state.templateList.map((element, index) => (
																	<Option
																		selected={this.state.templateList.length === 1}
																		key={element.id}
																		value={index}
																	>
																		{element.name}
																	</Option>
																))
															)}
														</Select>
													</Col>
													<div style={{ 'padding-top': 5 }}>
														<Col span={24}>
															<Card>
																<div style={{ padding: 5 }}>
																	{this.state.selectedTemplateArray.map((element, index) =>
																		/{{.*}}/.test(element) ? (
																			<input
																				required
																				key={index}
																				id={'input-' + index}
																				onChange={this.handleTemplateDefaults.bind(this, index)}
																				value={defaultTemplateValue}
																			/>
																		) : (
																			element && <FormattedMessage key={index} id={element} />
																		),
																	)}
																</div>
															</Card>
														</Col>
													</div>
												</>
											) : (
												<>
													<TextArea
														placeholder={this.props.language.language.type_your_msg}
														allowClear
														id="msgText"
														ref="msgText"
														onChange={this.onChangeMessage.bind(this)}
														disabled={this.state.isSendingMessage}
														autoSize={{ minRows: 5 }}
													/>
												</>
											)}
										</Card>
									</div>
								</Col>
								<Col span={24}>
									<div style={{ padding: 5 }}>
										<Upload.Dragger
											name="files"
											customRequest={this.dummyRequest}
											fileList={this.state.files}
											beforeUpload={this.beforeUpload}
											showUploadList={{
												showDownloadIcon: false,
												downloadIcon: 'download',
												showRemoveIcon: true,
											}}
											onRemove={this.removeFile.bind(this)}
											disabled={this.state.isSendingMessage}
										>
											<p className="ant-upload-drag-icon">
												<Icon type="inbox" />
											</p>
											<p className="ant-upload-text">
												{this.props.language.language.files_text1_mobile}
											</p>
											<p className="ant-upload-hint">{this.props.language.language.files_text2}</p>
										</Upload.Dragger>
									</div>
								</Col>
								<Col span={24} style={{ marginTop: 5 }}>
									{this.state.maxFileSize === true ? (
										<div style={{ padding: 5 }}>
											<Alert
												message={<FormattedMessage id="warning_maximum_file_size" />}
												type="error"
												showIcon
											/>
										</div>
									) : (
										<></>
									)}
								</Col>
								<Button
									type="link"
									onClick={this.sendMsg.bind(this)}
									loading={this.state.isSendingMessage}
									style={{
										display: 'inline-block',
										padding: '5px 70px',
										backgroundColor: '#bbed21',
										borderRadius: 0,
										textAlign: 'center',
										marginBottom: 10,
										color: '#535c69',
										fontWeight: 600,
										width: '100%',
										border: 'none',
										boxShadow: 'none',
									}}
								>
									<FormattedMessage id="send_msg" />
								</Button>
							</Row>
						</>
					)}
				</div>
			</>
		);
	}
}

export default Bitrix24Consumer(
	NumberConsumer(LanguageConsumer(SystemConsumer(MessageItemMobile))),
);
